export default "__VITE_ASSET__Bh0ovCkk__"